import { TokenStorage } from './token-storage';

export class JsVariableStorage  extends TokenStorage {
  lifespanInMilliseconds: number;
  storage = <Record<string, StorageRecord>> {};

  constructor(lifespan: number) {
    super();
    this.lifespanInMilliseconds = lifespan * 60 * 1000;
  }

  getItem(name: string): string {
    const record = this.storage[name];
    if (record) {
      if (record.expiration > Date.now()) {
        return record.value;
      } else {
        this.removeItem(name);
      }
    }
    return '';
  }

  removeItem(name: string): void {
    delete this.storage[name];
  }

  setItem(name: string, value: string): void {
    this.storage[name] = {
      value: value,
      expiration: Date.now() + this.lifespanInMilliseconds
    };
  }

  clear(): void {
    this.storage = {};
  }

}

interface StorageRecord {
  value: string;
  expiration: number;
}